import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, DownloadIcon, MonitorSmartphoneIcon } from 'lucide-react';
const benefits = [{
  icon: DownloadIcon,
  title: 'Instant PDF Access',
  description: 'Download immediately after purchase. Start reading in seconds, not days.'
}, {
  icon: MonitorSmartphoneIcon,
  title: 'Optimized for All Devices',
  description: 'Optimized for Mobile, Tablets, and E-readers. Your book, everywhere.'
}, {
  icon: ShieldCheckIcon,
  title: 'Secure Editorial Distribution',
  description: 'Your payment and download are protected with industry-standard encryption.'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.8,
      ease: 'easeOut'
    }
  }
};
export function DigitalBenefitsSection() {
  return <section className="py-24 px-6 md:px-8 bg-charcoal-900" data-id="element-1">
      <div className="max-w-6xl mx-auto" data-id="element-2">
        <motion.div className="text-center mb-16" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.5
      }} transition={{
        duration: 0.6
      }} data-id="element-3">
          <p className="text-patriotRed uppercase tracking-[0.2em] text-sm font-semibold mb-4" data-id="element-4">
            DIGITAL FEATURES
          </p>
          <h2 className="text-3xl md:text-5xl font-bold text-offwhite" data-id="element-5">
            Instant. Optimized. Secure.
          </h2>
        </motion.div>

        <motion.div className="grid grid-cols-1 md:grid-cols-3 gap-8" initial="hidden" whileInView="visible" viewport={{
        once: true,
        amount: 0.2
      }} variants={containerVariants} data-id="element-6">
          {benefits.map((benefit, index) => {
          const Icon = benefit.icon;
          return <motion.div key={index} variants={itemVariants} className="bg-charcoal-800 p-8 flex flex-col items-center text-center border border-charcoal-700/50" data-id="element-7">
                <div className="w-16 h-16 rounded-full bg-charcoal-900 flex items-center justify-center mb-6 text-patriotRed border border-charcoal-700" data-id="element-8">
                  <Icon className="w-8 h-8" strokeWidth={1.5} data-id="element-9" />
                </div>
                <h3 className="text-xl font-bold text-offwhite mb-4 font-serif" data-id="element-10">
                  {benefit.title}
                </h3>
                <p className="text-offwhite-muted font-light leading-relaxed" data-id="element-11">
                  {benefit.description}
                </p>
              </motion.div>;
        })}
        </motion.div>
      </div>
    </section>;
}